<header wdNavbarHeight>
<wd-dev-warning-banner [isDevelopment]="dbConfig.isDevelopment" [label]="'Datenbank: ' + dbConfig.punkteDbName + ' @ ' + apiBaseUrl"></wd-dev-warning-banner>
<lz-pwa-install-banner appName="BpWeb" [requireServiceWorker]="false"
	fallbackHint="Nutzen Sie Chrome oder Edge, um BpWeb als App zu installieren."></lz-pwa-install-banner>
<nav class="navbar navbar-expand-lg navbar-light bg-light" [ngClass]="{'local': oms.offlineMode()}">
	<div class="container-fluid d-flex justify-content-between align-items-center flex-nowrap overflow-visible gap-2">
		<div class="d-flex align-items-center gap-1">
			<button [disabled]="ds.isBusy" type="button" class="btn btn-default btn-home" (click)="onHomeClick($event)" placement="end" [ngbTooltip]="`BpWeb ${version}`">
				<i class="bi bi-house"></i><span class="d-none d-md-inline app-version">BpWeb {{ version }}</span>
				<span *ngIf="us.updateReady()" class="update-badge"></span>
			</button>
			<button type="button" class="btn btn-default btn-changelog" (click)="openChangelog()" title="Neuigkeiten">
				<i class="bi bi-journal"></i>
				<span *ngIf="cls.hasUnread()" class="changelog-badge"></span>
			</button>
		</div>
		<div>
			<div class="btn-group" role="group">
				<ng-container *ngIf="canEdit() | async">
					<button *ngIf="ns.isActive(C.savePoint) && onPointRoute()" [disabled]="ds.isBusy || networkUnavailable()" type="button" class="btn btn-default"
						(click)="ns.command(C.savePoint).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Punkt Speichern'">
						<span class="d-none d-md-inline">Punkt Speichern</span> &nbsp;<i class="bi bi-download"></i>
					</button>
				</ng-container>

				<!-- Zurück-Buttons (immer sichtbar, nicht nur für Bearbeiter) -->
				<button *ngIf="ns.isActive(C.goBack)" [disabled]="ds.isBusy" type="button" class="btn btn-default"
					(click)="ns.command(C.goBack).emit()" title="Zurück">
					<span class="d-none d-md-inline">Zurück</span> &nbsp;<i class="bi bi-arrow-left"></i>
				</button>
				<button *ngIf="ns.isActive(C.goBackToPoint)" [disabled]="ds.isBusy" type="button" class="btn btn-default"
					(click)="ns.command(C.goBackToPoint).emit()" title="Zurück zum Punkt">
					<span class="d-none d-md-inline">Zurück</span> &nbsp;<i class="bi bi-arrow-left"></i>
				</button>

				<!-- Fehler-Badges (Library-Komponenten) -->
				@if (isDeveloper()) {
					<wd-error-badge mode="all"></wd-error-badge>
				}
				@if (isProjectManager() || isDeveloper()) {
					<wd-error-badge mode="unknown"></wd-error-badge>
				}
				<!-- Status-Indikatoren (Library-Komponenten) -->
				<bp-presence-badge></bp-presence-badge>
				<wd-storage-status></wd-storage-status>
				<wd-connection-status></wd-connection-status>
				<wd-gps-status (gpsClicked)="onGpsHome()"></wd-gps-status>
				<wd-compass-rose></wd-compass-rose>
				<div ngbDropdown container="body" placement="bottom-end" display="dynamic"
					class="d-inline-block position-static">
					<button type="button" class="btn btn-secondary" id="bp-dropdown" ngbDropdownToggle title="Weitere Optionen">
						<i class="bi bi-list"></i>
						<!--
							Kein Warnzeichen mehr für die abgelaufene Anmeldung an diesem
							Knopf (06.09.2026): Der Balken über der Leiste
							(`wd-sitzungs-hinweis` in app.component.html) sieht selbst nach
							und bietet „Neu anmelden" an.
						-->
					</button>
					<div ngbDropdownMenu aria-labelledby="bp-dropdown">
						<ng-container *ngIf="isAuthenticated()">
						<button ngbDropdownItem *ngIf="ns.isActive(C.savePoint) && onPointRoute()" [disabled]="ds.isBusy || networkUnavailable()" type="button"
							class="btn btn-success" (click)="ns.command(C.savePoint).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Punkt Speichern'">
							<i class="bi bi-download"></i>&nbsp;Punkt Speichern
						</button>
						<hr *ngIf="ns.isActive(C.savePoint) && onPointRoute()">
						<button ngbDropdownItem *ngIf="ns.isActive(C.discardPoint)" [disabled]="ds.isBusy" type="button" class="btn"
							(click)="ns.command(C.discardPoint).emit()" title="Verwerfen">
							<i class="bi bi-x"></i>&nbsp;Verwerfen
						</button>
						<button ngbDropdownItem *ngIf="ns.isActive(C.goBack)" [disabled]="ds.isBusy" type="button" class="btn"
							(click)="ns.command(C.goBack).emit()" title="Zurück">
							<i class="bi bi-arrow-left"></i>&nbsp;Zurück
						</button>
						<hr *ngIf="ns.isActive(C.discardPoint) || ns.isActive(C.goBack)">
						<button ngbDropdownItem *ngIf="ns.isActive(C.goBackToPoint)" [disabled]="ds.isBusy" type="button"
							class="btn" (click)="ns.command(C.goBackToPoint).emit()" title="Zurück zum Punkt">
							<i class="bi bi-arrow-left"></i>&nbsp;Zurück
						</button>
						<hr *ngIf="ns.isActive(C.goBackToPoint)">
						<!-- Auswahl-Aktionen: nur sinnvoll mit offenem Projekt (Ziel/Workflow = aktives Projekt) -->
						<ng-container *ngIf="hasProject()">
						<button ngbDropdownItem *ngIf="ns.isActive(C.freigebenSelection) && !isGuest()" [disabled]="ds.isBusy || networkUnavailable()" type="button" class="btn"
							(click)="ns.command(C.freigebenSelection).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Ausgewählte Altpunkte in dieses Projekt übernehmen — Workflow-Reset; falls sie zu einem anderen Projekt gehören, werden sie dort entzogen'">
							<i class="bi bi-arrow-repeat"></i>&nbsp;Auswahl in dieses Projekt übernehmen
						</button>
						<button ngbDropdownItem *ngIf="ns.isActive(C.zuruecknehmenSelection) && !isGuest()" [disabled]="ds.isBusy || networkUnavailable()" type="button" class="btn"
							(click)="ns.command(C.zuruecknehmenSelection).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Übernahme der ausgewählten Punkte zurücknehmen — zurück auf „Abgeschlossen“ und ins vorige Projekt (oder Bestand, falls es das Projekt nicht mehr gibt)'">
							<i class="bi bi-arrow-counterclockwise"></i>&nbsp;Übernahme der Auswahl zurücknehmen
						</button>
						<!-- „Auswahl löschen" nur, wenn auch wirklich etwas ausgewählt ist
						     (hasSelection()) — sonst hat der Eintrag kein Ziel. -->
						<button ngbDropdownItem *ngIf="ns.isActive(C.deleteSelection) && hasSelection()" [disabled]="ds.isBusy || networkUnavailable()" type="button" class="btn"
							(click)="ns.command(C.deleteSelection).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Ausgewählte Punkte löschen'">
							<i class="bi bi-trash"></i>&nbsp;Auswahl löschen
						</button>
						<hr *ngIf="(ns.isActive(C.freigebenSelection) && !isGuest()) || ns.isActive(C.zuruecknehmenSelection) || (ns.isActive(C.deleteSelection) && hasSelection())">
						</ng-container>
						<!-- Direkt über „Punkt löschen" (Nutzer-Wunsch 28.09.2026). Kein Netz nötig:
						     Der andere Punkt kommt aus derselben Datenbank wie der offene. -->
						<button ngbDropdownItem *ngIf="ns.isActive(C.punktdatenHolen)" [disabled]="ds.isBusy" type="button" class="btn"
							(click)="ns.command(C.punktdatenHolen).emit()" title="Abschnitte aus einem anderen Punkt dieses Projekts übernehmen">
							<i class="bi bi-box-arrow-in-down"></i>&nbsp;Aus anderem Punkt übernehmen
						</button>
						<button ngbDropdownItem *ngIf="ns.isActive(C.deletePoint)" [disabled]="ds.isBusy || networkUnavailable()" type="button" class="btn"
							(click)="ns.command(C.deletePoint).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Punkt löschen'">
							<i class="bi bi-trash"></i>&nbsp;Punkt löschen
						</button>
						<hr *ngIf="ns.isActive(C.deletePoint) || ns.isActive(C.punktdatenHolen)">
						<!-- Offline-Modus: Synchronisieren -->
						<ng-container *ngIf="oms.offlineMode() && ns.isActive(C.checkIn)">
							<button ngbDropdownItem
								[disabled]="ds.isBusy" type="button" class="btn" (click)="onSync()" title="Änderungen synchronisieren">
								<i class="bi bi-arrow-repeat"></i>&nbsp; Synchronisieren
							</button>
							<hr>
						</ng-container>
						<!-- Import-Assistent + Sammelbearbeitung: gemeinsamer Abschnitt
						     (beides „Werkzeuge", die mehrere Protokolle auf einmal betreffen).
						     Kein Trenner dazwischen — ein Block, ein Trenner darunter. -->
						<button ngbDropdownItem *ngIf="ns.isActive(C.importWizard)" [disabled]="ds.isBusy" type="button"
							class="btn" (click)="ns.command(C.importWizard).emit()">
							<i class="bi bi-box-arrow-in-down"></i>&nbsp;Import-Assistent
						</button>
						<!-- Sammelbearbeitung (vormals „Batch-Edit-Assistent"): Editor freigegeben für
						     alle Punkt-Schreibberechtigten (Bearbeiter/Kontrolleur-Member/Owner/Entwickler);
						     Gate = canIbatchEdit() = write:points (PERMISSIONS.md §7); Manager/
						     Datennutzer außen vor. Per-Punkt-Gate beim Ausführen: canIWritePoint (G8).
						     Der Verlauf darunter (Historie + Rückgängig) bleibt bis auf Weiteres
						     NUR für Entwickler (Entscheidung 2026-06-16) — daher dort weiterhin
						     [disabled] gegen isDeveloper(). -->
						<button ngbDropdownItem *ngIf="ns.isActive(C.batchEdit)" [disabled]="ds.isBusy" type="button"
							class="btn" title="Mehrere Protokolle gleichzeitig bearbeiten" (click)="ns.command(C.batchEdit).emit()">
							<i class="bi bi-pencil-square"></i>&nbsp;Sammelbearbeitung
						</button>
						<button ngbDropdownItem *ngIf="ns.isActive(C.batchEditHistory)" [disabled]="ds.isBusy || !isDeveloper()" type="button"
							class="btn" [title]="isDeveloper() ? 'Verlauf der Sammelbearbeitungen anzeigen und rückgängig machen' : 'Nur für Entwickler verfügbar'" (click)="ns.command(C.batchEditHistory).emit()">
							<i class="bi bi-clock-history"></i>&nbsp;Sammelbearbeitung – Verlauf
						</button>
						<hr *ngIf="ns.isActive(C.importWizard) || ns.isActive(C.batchEdit) || ns.isActive(C.batchEditHistory)">
						<!-- GIS-Export + PDF: Abschnitt für Datenübergabe -->
						<ng-container *ngIf="hasProject()">
							<button ngbDropdownItem *ngIf="ns.isActive(C.gisExport)" [disabled]="ds.isBusy" type="button" class="btn"
								title="Punkte und Zeichnungen ans GIS übergeben (GeoJSON/Shapefile/GeoPackage)"
								(click)="ns.command(C.gisExport).emit()">
								<i class="bi bi-download"></i>&nbsp; GIS-Export (Punkte + Zeichnungen)
							</button>
							<button ngbDropdownItem *ngIf="ns.isActive(C.exportPdf)" [disabled]="ds.isBusy" type="button" class="btn" title="Ausgewählte Punkte als PDF exportieren"
								(click)="ns.command(C.exportPdf).emit()">
								<i class="bi bi-file-pdf"></i>&nbsp; Export als PDF
							</button>
							<!-- Druck-Layout-Designer: druckfertige Kartenlayouts (Karte, Text, Bild,
							     Maßstab, Legende, Nordpfeil, Zeichenelemente) pro Projekt gestalten.
							     Seiten-Navigation wie Handbuch (routerLink), daher kein Command-Enum.
							     NUR Entwickler (PERMISSIONS.md §8): sonst ausgegraut + keine Navigation
							     (Route zusätzlich per Guard gesperrt). -->
							<a ngbDropdownItem type="button" class="btn"
								[class.disabled]="!canSeeDruckLayout()"
								[attr.aria-disabled]="canSeeDruckLayout() ? null : 'true'"
								[routerLink]="canSeeDruckLayout() ? '/druck-layout' : null"
								title="Druck-Layout: druckfertige Kartenlayouts gestalten (nur Entwickler)">
								<i class="bi bi-easel"></i>&nbsp; Druck-Layout
							</a>
							<!-- Flaechen bearbeiten: schaltet den Editier-Modus fuer Standort-/
							     Humusform-Flaechen um (eigene Karten-Toolbar). Nur wenn die App
							     eine Geom-DB bereitstellt (GEOM_STORE) UND NUR fuer Entwickler
							     (sonst ausgegraut). -->
							<button ngbDropdownItem *ngIf="geomEditor.available" type="button" class="btn"
								[disabled]="!darfFlaechenBearbeiten()"
								[class.active]="geomEditor.editMode()"
								(click)="geomEditor.toggleEditMode()"
								[title]="darfFlaechenBearbeiten() ? 'Flaechen bearbeiten: Standort-/Humusform-Flaechen zeichnen und teilen' : 'Nur fuer Entwickler'">
								<i class="bi bi-pencil-square"></i>&nbsp; Flächen bearbeiten{{ geomEditor.editMode() ? ' – an' : '' }}
							</button>
						</ng-container>
						<hr *ngIf="hasProject()">
						</ng-container>
						<ng-container *ngIf="isAuthenticated()">
						<!-- Verwaltung: Listenverwaltung (Admin ODER Entwickler ODER Manager) +
						     Benutzerverwaltung (strikt admin, App-Verwaltung-Capability vom
						     Keycloak-Client) + Wartung (Lokalen Speicher Bereinigen). -->
						<a ngbDropdownItem *ngIf="listenverwaltungEnabled$ | async" type="button" class="btn" routerLink="/listenverwaltung" title="Listenverwaltung">
							<i class="bi bi-list-ul"></i>&nbsp; Listenverwaltung
						</a>
						<a ngbDropdownItem *ngIf="userManagementEnabled$ | async" type="button" class="btn" routerLink="/admin/users" title="Benutzerverwaltung">
							<i class="bi bi-people"></i>&nbsp; Benutzerverwaltung
						</a>
						<a ngbDropdownItem *ngIf="canSeeDatenbankverwaltung()" type="button" class="btn" routerLink="/admin/databases" title="Datenbankverwaltung">
							<i class="bi bi-hdd-stack"></i>&nbsp; Datenbankverwaltung
						</a>
						<!-- Projekte und Nutzung über ALLE Luzula-Apps. Zeigt fremde Projekte
						     samt Eigentümern — deshalb ausschließlich für Entwickler, und für
						     alle anderen gar nicht erst gerendert (nicht ausgegraut). -->
						<button ngbDropdownItem *ngIf="isDeveloper()" type="button" class="btn"
							(click)="openProjektUebersicht()"
							title="Wer hat welches Projekt wann angelegt oder geändert – über alle Luzula-Apps">
							<i class="bi bi-speedometer2"></i>&nbsp; Projekte und Nutzung
						</button>
						<!-- Kein Trenner zwischen den Admin-Links und „Lokalen Speicher
						     Bereinigen": der Button ist nur für Entwickler aktiv, sonst stünden
						     hier zwei <hr> direkt hintereinander (leerer Abschnitt). Ein Block. -->
						<button ngbDropdownItem *ngIf="ns.isActive(C.cleanUp) && (isProjectManager() || isDeveloper())" [disabled]="ds.isBusy" type="button" class="btn"
							(click)="ns.command(C.cleanUp).emit()">
							<i class="bi bi-trash"></i>&nbsp; Lokalen Speicher Bereinigen
						</button>
						</ng-container>
						<!-- Handbuch + Bodenformenkatalog + SEA-Suche: eigener Referenz-Abschnitt
						     direkt über dem Benutzer. Alle ungegated (public Reader-Routen) — auch
						     vor der Anmeldung sichtbar (Handbuch-Kontrakt). Der Trenner darüber
						     ist auth-gegated, damit vor dem Login kein verwaister <hr> erscheint. -->
						<hr *ngIf="isAuthenticated()">
						<a ngbDropdownItem type="button" class="btn" routerLink="/handbuch" title="Handbuch">
							<i class="bi bi-book"></i>&nbsp; Handbuch
						</a>
						<a ngbDropdownItem type="button" class="btn" routerLink="/bodenformenkatalog" title="Bodenformenkatalog">
							<i class="bi bi-journal-text"></i>&nbsp; Bodenformenkatalog
						</a>
						<a ngbDropdownItem type="button" class="btn" routerLink="/sea-suche" title="SEA-Suche: Wortlaut der SEA 95 durchsuchen">
							<i class="bi bi-search"></i>&nbsp; SEA-Suche
						</a>
						<ng-container *ngIf="isAuthenticated()">
						<hr>
						<button *ngIf="currentUser()" type="button" class="btn d-inline-flex align-items-center gap-2"
							(click)="openProfile()" title="Mein Profil">
							<lz-avatar [userId]="currentUserId()" [name]="currentUser()" [size]="24" [hasAvatar]="hasOwnAvatar" [cacheBust]="avatarCacheBust"></lz-avatar>
							<span>{{currentUser()}}</span>
						</button>
						</ng-container>
						<bp-auth-button *ngIf="!oms.offlineMode()" (loggedOut)="onLoggedOut()"></bp-auth-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</nav>
</header>
